import request from '@/utils/request'

const apis = {
  getData: '/drinks/app/v1/balance/detail',
  transfer: '/drinks/app/v1/balance/balanceOrGoldTransfer'
}

// 获取余额明细数据
export const getData = (data) => {
  return request({
    method: 'POST',
    url: apis.getData,
    data
  })
}

// 余额转账
export const transfer = (data) => {
  return request({
    method: 'POST',
    url: apis.transfer,
    data
  })
}
